import { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import ib_logo from '../img/ib-circle-logo.png';
import { Notification, useRedirect, useNotify } from 'react-admin';
import { API_ROOT } from '../transport-layer/src';
import { useClientContext } from '../contexts/client';
import Box from '@mui/material/Box';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const { state: client } = useClientContext();
  const CLIENT = client.client.resourcePrefix;
  const clientLogo = client.client.logo;
  const backgroundImage = client.client.backgroundImage;
  const redirect = useRedirect();
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data: any) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_ROOT}/rpc/forgot_password_request`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: data.email,
          client: CLIENT
        })
      });
      if (response.ok) {
        notify('Password Reset Request Sent', { 'type': 'info'});
        redirect('/login');
      } else {
        notify('User not found', { 'type': 'warning'});
      }
    } catch (error) {
      console.error('Error:', error);
      notify('An error occurred', { 'type': 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form 
        onSubmit={handleSubmit(onSubmit)} 
        noValidate
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'flex-start',
          background: `url(${backgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <Card sx={{ minWidth: 300, marginTop: '6em' }}>
          <Box
            sx={{
              margin: '1em',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img src={clientLogo} alt="Logo" height={'100px'} />
          </Box>
          <Box
            sx={{
              margin: '1em',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Avatar sx={{ bgcolor: 'secondary.main' }}>
              <VpnKeyIcon />
            </Avatar>
          </Box>
          <Box sx={{ padding: '0 1em 1em 1em' }}>
            <Typography variant="body2" gutterBottom>
              Please enter your email address below and we will send you a link which can be used to confirm your account and complete the password reset process.
            </Typography>
            <Box sx={{ marginTop: '1em' }}>
              <TextField
                autoFocus
                label="EMAIL ADDRESS"
                disabled={loading}
                fullWidth
                {...register('email', { required: 'Email is required' })}
                error={!!errors.email}
                helperText={errors.email ? String(errors.email.message) : ''}
              />
            </Box>
          </Box>
          <CardActions sx={{ padding: '0 1em 1em 1em' }}>
            <Button
              variant="contained"
              type="submit"
              color="primary"
              disabled={loading}
              fullWidth
            >
              {loading && (
                <CircularProgress
                  size={25}
                  thickness={2}
                />
              )}
              {'Request Password Reset'}
            </Button>
          </CardActions>
        </Card>
        <Notification />
        <Box sx={{ position: 'absolute', bottom: 10, left: 10 }}>
          <img src={ib_logo} height='35px' alt='infobate-logo' />
        </Box>
      </Box>
    </form>
  );
};

ForgotPassword.propTypes = {
  authProvider: PropTypes.func,
  previousRoute: PropTypes.string,
};

const ForgotPasswordWithTheme = (props: any) => (
  <ForgotPassword {...props} />
);

export default ForgotPasswordWithTheme;

